module.exports = __webpack_public_path__ + "41f772ce0f66e18a63cb9abdd6175b34.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/icons/dashboard-gray.png
// module id = 1727
// module chunks = 0